var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo_color_box_1"},[_c('div',{staticClass:"logo_color_box_2"},[_c('div',{staticClass:"title_box"},[(_vm.LogoPath)?_c('img',{staticStyle:{"height":"0.7rem","width":"0.7rem","margin-right":"0.3rem"},attrs:{"src":_vm.LogoPath,"alt":"logo"}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }